import { useState, useEffect, useCallback } from 'react';
import stockAdjustmentService from '../services/stockAdjustmentService';

export default function useStockAdjustmentStats(branchId = null, fromDate = null, toDate = null,period = null) {
  const [stats, setStats] = useState({
    totalAdjustments: 0,
    totalItemsAdjusted: 0,
    netAdjustmentValue: 0,
    avgVariancePercent: 0,
  });
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  const fetchStats = useCallback(async () => {
    setLoading(true);
    try {
      const data = await stockAdjustmentService.getStats(branchId, fromDate, toDate,period);
      setStats(data);
      setError(null);
    } catch (err) {
      console.error('Failed to fetch adjustment stats:', err);
      setError(err.message);
    } finally {
      setLoading(false);
    }
  }, [branchId, fromDate, toDate,period]);

  useEffect(() => {
    fetchStats();
  }, [fetchStats]);

  return { stats, loading, error, refetch: fetchStats };
}

export function useInventoryItemsForAdjustment(branchId = null) {
  const [inventoryItems, setInventoryItems] = useState([]);
  const [loading, setLoading]               = useState(true);
  const [error, setError]                   = useState(null);

  const fetchItems = useCallback(async () => {
    setLoading(true);
    try {
      const data = await stockAdjustmentService.getInventoryItemsForAdjustment(branchId);
      setInventoryItems(data);
      setError(null);
    } catch (err) {
      console.error('Failed to fetch inventory items:', err);
      setError(err.message);
    } finally {
      setLoading(false);
    }
  }, [branchId]);

  useEffect(() => {
    fetchItems();
  }, [fetchItems]);



  return { inventoryItems, loading, error, refetch: fetchItems };
}

export function useSubmitAdjustments() {
  const [isSubmitting, setIsSubmitting] = useState(false);
  const [error, setError]               = useState(null);

  const submitAdjustments = useCallback(async (adjustments) => {
    setIsSubmitting(true);
    setError(null);
    try {
      const result = await stockAdjustmentService.submitAdjustments(adjustments);
      return result;
    } catch (err) {
      console.error('Failed to submit adjustments:', err);
      setError(err.message);
      throw err;              // re-throw so the caller's try/catch still works
    } finally {
      setIsSubmitting(false);
    }
  }, []);

  return { submitAdjustments, isSubmitting, error };


}

export function useAdjustmentHistory(filters = {}) {
  const [history, setHistory]   = useState([]);
  const [loading, setLoading]   = useState(true);
  const [error, setError]       = useState(null);

  const fetchHistory = useCallback(async () => {
    setLoading(true);
    try {
      const data = await stockAdjustmentService.getAdjustmentHistory(filters);
      setHistory(data);
      setError(null);
    } catch (err) {
      console.error('Failed to fetch adjustment history:', err);
      setError(err.message);
    } finally {
      setLoading(false);
    }
  }, [filters.fromDate, filters.toDate, filters.search, filters.reason,filters.period]);

  useEffect(() => {
    fetchHistory();
  }, [fetchHistory]);

  return { history, loading, error, refetch: fetchHistory };
}
